import { tokens } from 'src/design-system';
import { interactive } from 'src/design-system/mixins';
import { commonStyles } from "src/Library/CommonStyles";

export const QuickAddContainerTrackingStyles = theme => ({
  ...commonStyles(theme),
  hintHeader: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    textAlign: 'left',
    paddingTop: '6px',
    lineHeight: 1.2
  },
  collapse: {
    '& .ant-collapse-item': {
      border: 'none !important',
    },
    '& .ant-collapse-header': {
      padding: '6px 28px !important',
      marginBottom: '10px !important',
      backgroundColor: `${tokens.colors.bgSubtle} !important`,
      color: `${theme.primaryColor} !important`,
    },
    '& .ant-collapse-arrow': {
      left: '11px !important',
    },
    '& .ant-collapse-content-box': {
      padding: '0 !important',
    },
    '& .ant-collapse-content': {
      overflow: 'unset',
    },
  },
  form: {
    '& .ant-form-item': {
      width: '100% !important',
    },
    ...interactive.antFormRequiredHide,
    '& .ant-form-item-label': {
      lineHeight: '26px',
    },
  },
  manualFormParent: {
    backgroundColor: tokens.colors.bgSubtle,
    padding: `${tokens.spacing.md}px ${tokens.spacing.lg}px`,
    marginBottom: '18px',
  },
  required: {
    color: tokens.colors.error,
  },
  accessInfo: {
    color: tokens.colors.textTertiary,
    fontSize: '9px',
    lineHeight: '12px',
    paddingTop: '6px',
    fontStyle: 'italic',
  },
  teamFIeld: {
    '& .ant-form-item-control-wrapper': {
      width: '100%',
    },
  },
  dropdownStyle: {
    color: theme.primaryColor,
    fontSize: tokens.fontSize.body,
    padding: `${tokens.spacing.sm + 2}px ${tokens.spacing.ms}px`,
    cursor: 'pointer',
  },
  radio: {
    width: '120px',
    textAlign: 'center',
  },
  moreDetails: {
    color: theme.primaryColor,
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '19px',
    backgroundColor: tokens.colors.bgSubtle,
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  formItem: {
    '& .ant-form-item-children': {
      ...commonStyles(theme).flexRow,
      width: '100%',
    },
  },
  selectAddress: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.primary,
    cursor: 'pointer',
  },
  addressHeading: {
    color: tokens.colors.text,
    fontWeight: tokens.fontWeight.semibold,
  },
  addressOtherDetails: {
    color: tokens.colors.text,
    fontSize: tokens.fontSize.small,
    marginTop: '6px',
  },
  selectedAddress: {
    padding: '13px',
    borderRadius: tokens.radius.md,
    height: '100%',
    cursor: 'pointer',
  },
  slDownText: {
    fontSize: tokens.fontSize.small,
    color: '#FF5E2A',
    fontWeight: 550,
    fontStyle: 'italic',
  },
  rowStyles: {
    paddingBottom: tokens.spacing.sm + 2,
  },
});